import { PageType } from '@/constants'
import { type Keywords } from '@/types'
import { getTranslate } from '@/utils/api-interceptors'
import Link from 'next/link'
interface KeywordType {
  data: Keywords[],
  pageType?: string
}

export const Keyword = ({ data, pageType }: KeywordType) => {
  return (
    <>
      {data && data.length > 0 ? (
        <section className={`container mx-auto relative  z-20 bg-[#F3F4F6] ${pageType === PageType.HOMEPAGE ? 'top-[-64px]': ''}`}>
          <div className='flex w-full flex-wrap'>
            <div className='mb-4 w-full text-lg font-bold leading-tight'>
              Tìm kiếm nhiều nhất
            </div>
            <div className='flex pb-6 w-full flex-wrap gap-2'>
              {data &&
                data.map((e, i) => {
                  const label = getTranslate(e?.name)
                  // Keyword từ NK config có sẵn link đích; keyword từ API
                  // marketing thì không, nên fallback về trang tìm kiếm.
                  const href =
                    e?.href || `/search-result?query=${encodeURIComponent(label)}`
                  return (
                    <Link
                      href={href}
                      className='flex h-[30px] w-max cursor-pointer text-sm items-center rounded-[60px] border bg-white px-3'
                      key={i}
                    >
                      {label}
                    </Link>
                  )
                })}
            </div>
          </div>
        </section>
      ) : (
        ''
      )}
    </>
  )
}

export default Keyword
